/*
 * @Date: 2022-08-16 09:31:08
 * @LastEditTime: 2026-01-31 10:00:00
 * @Description: 用户状态管理 - 同步小程序端功能
 */
import router from "@/router";
import api from "@/api";
import { defineStore } from "pinia";
import useCommonStore from "../common";
import { message } from "ant-design-vue";

const useUserStore = defineStore("user", {
  state: () => ({
    token: "",
    userInfo: {},
    classList: [],
    messageCount: 0, // 未读消息数
  }),
  getters: {
    isLoggedIn: (state) => !!state.token,
    userId: (state) => state.userInfo?.userId,
    userName: (state) => state.userInfo?.userName || state.userInfo?.phone,
    avatar: (state) => state.userInfo?.avatar,
    role: (state) => state.userInfo?.role,
  },
  actions: {
    SET_TOKEN(token) {
      this.token = token;
    },
    SET_USER_INFO(data) {
      this.userInfo = data;
    },
    SET_MESSAGE_COUNT(count) {
      this.messageCount = count;
    },
    // 初始化用户状态（从localStorage恢复）
    initUserState() {
      const token = localStorage.getItem("token");
      const userInfo = localStorage.getItem("userInfo");
      if (token) {
        this.token = token;
        this.userInfo = userInfo ? JSON.parse(userInfo) : {};
        if (this.userInfo.role) {
          this.getClassList(this.userInfo.role);
        }
        this.getMessageStatus();
      }
    },
    // 获取班级列表
    getClassList(role) {
      api.getClassList({ role }).then((res) => {
        if (res) this.classList = res.data;
      });
    },
    // 获取未读消息数
    getMessageStatus() {
      if (!this.token) return;
      api.getMessageStatus({}).then((res) => {
        if (res) this.messageCount = res.data?.count || 0;
      });
    },
    // 获取用户信息
    async fetchUserInfo() {
      if (!this.token) return;
      const res = await api.getUserInfo({});
      if (res) {
        this.userInfo = res.data;
        localStorage.setItem("userInfo", JSON.stringify(res.data));
      }
      return res;
    },
    // 更新用户信息
    async updateUserInfo(data) {
      const res = await api.updateUserInfo(data);
      if (res) {
        await this.fetchUserInfo();
        message.success("更新成功", 2);
      }
      return res;
    },
    // 更新手机号
    async updatePhone(data) {
      const res = await api.updatePhone(data);
      if (res) {
        await this.fetchUserInfo();
        message.success("手机号更新成功", 2);
      }
      return res;
    },
    // 修改密码
    async updatePassword(data) {
      const res = await api.updatePassword(data);
      if (res) {
        message.success("密码修改成功，请重新登录", 2);
        this.logout();
      }
      return res;
    },
    // 登录入口
    LOGIN(params) {
      const { type, phone, data } = params;
      if (!phone || !data) return;
      if (type == 0) this.codeLogin(phone, data);
      else this.passwordLogin(phone, data);
    },
    // 验证码登录
    codeLogin(phone, code) {
      api.codeLogin({ phone, code }).then((res) => {
        if (res) this.actionResult(res);
      });
    },
    // 密码登录
    passwordLogin(phone, password) {
      api.passwordLogin({ phone, password }).then((res) => {
        if (res) this.actionResult(res);
      });
    },
    // 登录成功处理
    actionResult(res) {
      const { data } = res;
      const { token } = data;

      this.token = token;
      this.userInfo = data;

      localStorage.setItem("token", token);
      localStorage.setItem("userInfo", JSON.stringify(data));

      this.getClassList(data.role);
      this.getMessageStatus();

      message.success("登录成功", 2);
      const commonStore = useCommonStore();
      commonStore.SET_OPEN(false);
    },
    // 退出登录
    logout(name) {
      this.token = "";
      this.userInfo = {};
      this.classList = [];
      this.messageCount = 0;

      localStorage.removeItem("token");
      localStorage.removeItem("userInfo");

      let arr = [];
      const commonStore = useCommonStore();
      commonStore.personNav.forEach((nav) => {
        arr.push(nav.pathName);
      });
      arr = [...arr, "schoolEntrance", "schoolOnline", "schoolOffline"];
      if (arr.includes(name)) {
        router.push({ path: "/" });
      }
      message.success("退出成功", 2);
    },
    // 注销用户
    async logoffUser() {
      const res = await api.logoffUser({});
      if (res) {
        message.success("账号已注销", 2);
        this.logout();
      }
      return res;
    },
  },
});

export default useUserStore;
